export default [
  {
    inputs: [],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address'
      }
    ],
    name: 'OwnableInvalidOwner',
    type: 'error'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'OwnableUnauthorizedAccount',
    type: 'error'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_token',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256'
      }
    ],
    name: 'ownerWithdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_fromChainId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_toChainId',
        type: 'uint256'
      },
      {
        internalType: 'string',
        name: '_toTokenContractAddress',
        type: 'string'
      },
      {
        internalType: 'string',
        name: '_toAddress',
        type: 'string'
      },
      {
        internalType: 'uint256',
        name: '_amount0',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_amount1',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_tokenFee',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_ethFee',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_challengePeriod',
        type: 'uint256'
      },
      {
        internalType: 'string',
        name: '_remark',
        type: 'string'
      }
    ],
    name: 'receiveEther',
    outputs: [],
    stateMutability: 'payable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_fromChainId',
        type: 'uint256'
      },
      {
        internalType: 'address',
        name: '_fromTokenContractAddress',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_toChainId',
        type: 'uint256'
      },
      {
        internalType: 'string',
        name: '_toTokenContractAddress',
        type: 'string'
      },
      {
        internalType: 'string',
        name: '_toAddress',
        type: 'string'
      },
      {
        internalType: 'uint256',
        name: '_amount0',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_amount1',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_tokenFee',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_ethFee',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_challengePeriod',
        type: 'uint256'
      },
      {
        internalType: 'string',
        name: '_remark',
        type: 'string'
      }
    ],
    name: 'receiveToken',
    outputs: [],
    stateMutability: 'payable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_coldWallet',
        type: 'address'
      }
    ],
    name: 'setColdWallet',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_ethFeeTo',
        type: 'address'
      }
    ],
    name: 'setETHFeeTo',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_tokenFeeTo',
        type: 'address'
      }
    ],
    name: 'setTokenFeeTo',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'fromChainId',
        type: 'uint256'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'fromTokenContractAddress',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'fromAddress',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'toChainId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'string',
        name: 'toTokenContractAddress',
        type: 'string'
      },
      {
        indexed: false,
        internalType: 'string',
        name: 'toAddress',
        type: 'string'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount0',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount1',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tokenFee',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'ethFee',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'challengePeriod',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'string',
        name: 'remark',
        type: 'string'
      }
    ],
    name: 'tokenReceived',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'chainId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'withdrawToken',
    type: 'event'
  },
  {
    stateMutability: 'payable',
    type: 'receive'
  },
  {
    inputs: [],
    name: 'coldWallet',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'ethFeeTo',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getChainId',
    outputs: [
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'tokenFeeTo',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  }
] as const
